import { useMemo } from 'react';

import { OwnerCard } from '@/shared/ui/OwnerCard';

import { useDisplaySettingsStore } from '@/entities/display-settings';
import { DomainTree } from '@/entities/domain';

import { useTagCategoryDetail, useTagDomainEdit, useTagOwnerEdit } from '@/features/tags/model';

type TagCategorySidebarProps = {
  selectedTagCategory: string;
};

export const TagCategorySidebar = ({ selectedTagCategory }: TagCategorySidebarProps) => {
  const showOwners = useDisplaySettingsStore((state) => state.showOwners);
  const { data } = useTagCategoryDetail({
    categoryName: selectedTagCategory ?? '',
  });

  const owners = useMemo(() => data?.owners || [], [data?.owners]);
  const ownerEdit = useTagOwnerEdit({
    tagCategoryId: data?.id ?? '',
    tagCategory: selectedTagCategory,
  });

  const domainEdit = useTagDomainEdit({
    tagCategoryId: data?.id ?? '',
    categoryName: selectedTagCategory ?? '',
  });

  return (
    <>
      {showOwners && <OwnerCard title="소유자" owners={owners} ownerEdit={ownerEdit} />}
      <DomainTree
        title="도메인"
        domainData={data?.domains ?? []}
        onSave={domainEdit.handleSave}
        isUpdating={domainEdit.isUpdating}
      />
    </>
  );
};
